import { useState } from 'react';
import { createGlobalStore } from 'hox';
import { CustomRouteObject } from '@/routes';

const homeBreadcrumb: CustomRouteObject = { title: 'Home', path: '/' };
const useBreadcrumbResolve = () => {
  const [breadcrumb, setBreadcrumb] = useState<CustomRouteObject[]>([homeBreadcrumb]);

  const handleSetBreadcrumb = (data: CustomRouteObject[]) => {
    setBreadcrumb([homeBreadcrumb].concat(data.filter((item) => item !== undefined)));
  };

  return {
    breadcrumb,
    handleSetBreadcrumb,
  };
};

export const [useBreadcrumbStore, getBreadcrumbStore] = createGlobalStore(useBreadcrumbResolve);
